const FooterToggle = () => {

    // Slide down submenus (on open)
    const slideDown = element => element.style.height = `${element.scrollHeight}px`;

    // Slide up submenus (on close)
    const slideUp = element => element.style.height = '0px';

    // Fetch all links with data-toggle attached
    let toggles = document.querySelectorAll('[data-footer-toggle]');

    Array.from(toggles).forEach(toggle => {

        // Fetch the reference in the data attribute
        let targetAttr = toggle.getAttribute('data-footer-toggle');
        // Use the reference to fetch the matching element to toggle open/closed
        let targetElement = document.querySelector(`[data-footer-item="${targetAttr}"]`);
        
        // If the element is defined/exists, proceed
        if (typeof targetElement != "undefined" && targetElement != null) {

            // When the link is clicked
            toggle.addEventListener('click', () => {

                // If the toggle div already has the active class
                if (toggle.matches('.top-footer__wrap--active')) {
                    // Remove the active class
                    toggle.classList.remove('top-footer__wrap--active');
                    // Close the proceeding element
                    slideUp(targetElement);
                } else {
                    // Add the active class
                    toggle.classList.add('top-footer__wrap--active');
                    // Open the proceeding element
                    slideDown(targetElement);
                }
            });
        }
    });
}

export default FooterToggle;